import React, { Component } from "react";
import { Nav, NavItem, NavLink, TabContent } from "reactstrap";
import cookie from "react-cookies";
import { isEmpty } from "lodash";
import classnames from "classnames";

import { apiBaseUrl } from "../../configs/configs";
import CustomBreakup from "./customBreakup/custom";

class PredictionBreakup extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activeTab: "2",
    };

    console.log(">>>dataa",this.props.location.data)

    this.toggleTab = this.toggleTab.bind(this);
    this.getContestStructureData = this.getContestStructureData.bind(this);

    this.getContestStructureData()
      .then((res) => {
        console.log("res.result", res.result);
        this.setState({
          contestData: res.result,
        });
      })
      .catch((e) => console.log(e));
  }

  async getContestStructureData() {
    const contestId = this.state.contestId;
    const token = cookie.load("token");
    const getUserDataApi = `${apiBaseUrl}/contests/detail?id=${contestId}`;
    const response = await fetch(getUserDataApi, {
      headers: {
        token: token,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    });

    if (response.status === 200) {
      const jsonResponse = await response.json();
      return jsonResponse;
    } else {
      return new Error();
    }
  }

  toggleTab(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  }

  render() {
    return (
      <div>
        <Nav tabs>
          <NavItem>
            <NavLink
              className={classnames({ active: this.state.activeTab === "2" })}
              onClick={() => {
                this.toggleTab("2");
              }}
            >
              Custom Breakup
            </NavLink>
          </NavItem>
        </Nav>
        <TabContent activeTab={this.state.activeTab}>
          {!isEmpty(this.props.location.data) &&
            (
              <CustomBreakup contestData={this.props.location.data} />
            )}
        </TabContent>
      </div>
    );
  }
}

export default PredictionBreakup;
